import script from "./Speedometer.vue?vue&type=script&setup=true&lang=js"
export * from "./Speedometer.vue?vue&type=script&setup=true&lang=js"

import "./Speedometer.vue?vue&type=style&index=0&id=8a044aba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a044aba"]])

export default __exports__